import { useNavigate } from 'react-router-dom';
import { PageHeader } from 'src/components/ui/GlobalComponents/PageHeader/PageHeader';
import styles from './CreateCustomList.module.scss';
import { CustomListForm } from './CustomListForm/CustomListForm';

export const CreateCustomList = () => {
    const navigate = useNavigate();



    const handleBackClick = () => {
        navigate('/wordlists');
    }

    return (
        <section className={styles.createCustomList}>
            <PageHeader
                title='Create new list'
                handleBackClick={handleBackClick} />
            <CustomListForm />
        </section>
    );
};
